
import { defineComponent } from 'vue'
import PatientEncounters from '../components/encounter/PatientEncounters.vue'

export default defineComponent({
  name: 'EncounterView',
  components: { PatientEncounters }
})
